export default __webpack_public_path__ + "static/media/arrow-side-gray.f50b5804.svg";